import { default as buildSearch } from './buildSearch'
import { default as parseSearch } from './parseSearch'

const serverError = {
  buildSearch,
  parseSearch,
}

export default serverError
